
ADILF.define('streamhub-sdk/ui/command',['require','exports','module','streamhub-ui/command'],function (require, exports, module) {module.exports = require('streamhub-ui/command');

});
